import React from 'react';
import './FSSC.css';
import './FSSCSubPages.css'; // Import the CSS for sub-page content

import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from ".././components/ui/carousel"
import { Card, CardContent } from '.././components/ui/card';

const FSSC: React.FC = () => {

  return (
    <div className="min-h-screen bg-[#FFF6E0] text-[#D7263D] font-sans">
      
      {/* Hero Section */}
      <div className="flex flex-col items-center justify-center mt-8 pb-8 px-4">
      <img 
          src="/fssc-hero.png" 
          alt="Front St Supper Club" 
          className="w-full max-w-3xl mx-auto drop-shadow-xl rounded-2xl border-4 border-[#D7263D]"
          style={{ background: '#FFF6E0' }}
        />
        <h1 
          className="text-5xl md:text-7xl mt-8 mb-2 text-[#D7263D] text-center drop-shadow-sm pt-6"
          style={{
            fontFamily: "'Savate', sans-serif",
            fontOpticalSizing: "auto",
            fontWeight: 200,
            fontStyle: "normal"
          }}
        >
          Made with an extra pinch of love
        </h1>
      </div>

      {/* About Section */}
      <section className="py-8 px-4">
        <div className="max-w-3xl mx-auto bg-white/80 rounded-xl shadow-lg border-2 border-[#D7263D] p-8">
          <div
            className="text-center mb-8"
          >
            <h2 
              className="text-3xl md:text-4xl mb-4 text-[#D7263D]"
              style={{
                fontFamily: "'Savate', sans-serif",
                fontOpticalSizing: "auto",
                fontWeight: 200,
                fontStyle: "normal"
              }}
            >
              Our Story
            </h2>
            <p className="text-[#2E294E] text-lg leading-relaxed font-medium">
              Welcome to Front St Supper Club, where we bring together exceptional cuisine and meaningful connections. Each gathering is a celebration of local ingredients, culinary creativity, and the joy of shared experiences. Expect a little magic, a lot of flavor, and plenty of heart.
            </p>
          </div>
          <div className='fssc-carousel'>

      <Carousel className="w-full max-w-xs">
      <CarouselContent>
      <CarouselItem>
              <img src="/drinks.png" alt="Drinks" className="fssc-carousel-image" />
            </CarouselItem>
            <CarouselItem>
              <img src="/cake.png" alt="Cake" className="fssc-carousel-image" />
            </CarouselItem>
            <CarouselItem>
              <img src="/beef.jpg" alt="Beef" className="fssc-carousel-image" />
            </CarouselItem>
            <CarouselItem>
              <img src="/waffle.jpg" alt="Waffle" className="fssc-carousel-image" />
            </CarouselItem>
            <CarouselItem>
              <img src="/lobsta.png" alt="Lobster" className="fssc-carousel-image" />
            </CarouselItem>
      </CarouselContent>
      <CarouselPrevious />
      <CarouselNext />
    </Carousel>
    </div>
          <div className="flex flex-col md:flex-row gap-6 align-top">
            <div className="bg-[#F46036]/10 border-2 border-[#F46036] rounded-lg p-6 flex-1 text-center">
              <h3 
                className="text-xl mb-2 text-[#D7263D]"
                style={{
                  fontFamily: "'Savate', sans-serif",
                  fontOpticalSizing: "auto",
                  fontWeight: 200,
                  fontStyle: "normal"
                }}
              >
                Seasonal Menus
              </h3>
              <p className="text-[#2E294E]">Curated dishes featuring the finest local and seasonal ingredients</p>
            </div>
            <div className="bg-[#F46036]/10 border-2 border-[#F46036] rounded-lg p-6 flex-1 text-center">
              <h3 
                className="text-xl mb-2 text-[#D7263D]"
                style={{
                  fontFamily: "'Savate', sans-serif",
                  fontOpticalSizing: "auto",
                  fontWeight: 200,
                  fontStyle: "normal"
                }}
              >
                Intimate Setting
              </h3>
              <p className="text-[#2E294E]">Limited seating for an exclusive and personal dining experience</p>
            </div>
            <div className="bg-[#F46036]/10 border-2 border-[#F46036] rounded-lg p-6 flex-1 text-center">
              <h3 
                className="text-xl mb-2 text-[#D7263D]"
                style={{
                  fontFamily: "'Savate', sans-serif",
                  fontOpticalSizing: "auto",
                  fontWeight: 200,
                  fontStyle: "normal"
                }}
              >
                Community Focus
              </h3>
              <p className="text-[#2E294E]">Building connections through the shared experience of exceptional dining</p>
            </div>
          </div>
        </div>
      </section>
      
    </div>
  );
};

export default FSSC; 